import Link from 'next/link'
import { FC } from 'react'

import { BASE_URL } from '@/shared/lib/const/env'
import { TSection } from '@/shared/types/deprecated-types'
import { Image } from '@/shared/ui/Image'

import cls from './category-item.module.scss'

const IMAGES_SIZE_PX = 40

export type CategoryItemProps = {
	baseUrl?: boolean
} & TSection

export const CategoryItem: FC<CategoryItemProps> = ({ title, imgSrc, link }) => (
	<Link href={link} scroll={false} className={cls.root} prefetch={false}>
		<div className={cls.imageWrap}>
			{imgSrc ? (
				<Image
					src={BASE_URL + imgSrc}
					width={IMAGES_SIZE_PX}
					height={IMAGES_SIZE_PX}
					alt={title}
					placeholder="blur"
					priority
				/>
			) : (
				<div className={cls.emptyImage} />
			)}
		</div>
		<div className={cls.title}>{title}</div>
	</Link>
)
